import {
  CreatePlayslipThemeRequest,
  DeletePlayslipThemeRequest,
  GetPlayslipMessageCatalogRequest,
  GetPlayslipMessageCatalogResponse,
  GetPlayslipThemeRequest,
  GetPlayslipThemesRequest,
  GetPlayslipThemesResponse,
  PlayslipThemeCreateRequest,
  PlayslipTheme,
  PlayslipThemeUpdateRequest,
  PlayslipsAdminApi,
  UpdatePlayslipThemeRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(PlayslipsAdminApi)

const getPlayslipThemes = async (): Promise<GetPlayslipThemesResponse> => {
  const request: GetPlayslipThemesRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await getApi().getPlayslipThemes(request)
}

const getPlayslipTheme = async (themeId: string): Promise<PlayslipTheme> => {
  const request: GetPlayslipThemeRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    themeId,
  }

  return await getApi().getPlayslipTheme(request)
}

const createPlayslipTheme = async (theme: PlayslipThemeCreateRequest): Promise<PlayslipTheme> => {
  const request: CreatePlayslipThemeRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    playslipThemeCreateRequest: theme,
  }

  return await getApi().createPlayslipTheme(request)
}

const updatePlayslipTheme = async (
  themeId: string,
  updates: PlayslipThemeUpdateRequest,
): Promise<PlayslipTheme> => {
  const request: UpdatePlayslipThemeRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    themeId,
    playslipThemeUpdateRequest: updates,
  }

  return await getApi().updatePlayslipTheme(request)
}

const deletePlayslipTheme = async (themeId: string): Promise<void> => {
  const request: DeletePlayslipThemeRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    themeId,
  }

  return await getApi().deletePlayslipTheme(request)
}

const getPlayslipMessageCatalog = async (): Promise<GetPlayslipMessageCatalogResponse> => {
  const request: GetPlayslipMessageCatalogRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await getApi().getPlayslipMessageCatalog(request)
}

export const PlayslipThemeServiceAPI = {
  getPlayslipMessageCatalog,
  getPlayslipThemes,
  getPlayslipTheme,
  createPlayslipTheme,
  updatePlayslipTheme,
  deletePlayslipTheme,
}
